var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CcLive',{attrs:{"data":_vm.data,"default-app":{
      name: '此处填写直播信息',
      description: '此处为直播标题描述，描述内容支持一行显示'
    }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }